import { isEmpty } from "lodash/fp";

import { hasVideoRecording } from "@app/analytics/hooks/recordings/useRecordingInfo";
import { TrendSeriesItem } from "@app/analytics/types";
import {
  MeetingPlatform,
  UnauthorizedVideoRecording,
  VideoRecording,
} from "@app/common/types";
import Config from "@app/config";

/**
  @param data trend series
  @param target target value to match in array
  @param comparator value to compare by, defaults to "x"

  Finds the closest number to a target value in a trend series.
  If closest between two values, will return the item with the lowest index in the array
*/
export const getClosestInTrendSeries = (
  data: TrendSeriesItem[],
  target: number,
  comparator = "x" as keyof TrendSeriesItem
) => {
  if (isEmpty(data)) return null;

  return data.reduce((prev, curr) =>
    Math.abs(curr[comparator] - target) < Math.abs(prev[comparator] - target)
      ? curr
      : prev
  );
};

const RECORDING_NOT_SUPPORTED_PLATFORMS: MeetingPlatform[] = ["webex"];

export const platformDoesNotSupportRecording = (platform: MeetingPlatform) =>
  RECORDING_NOT_SUPPORTED_PLATFORMS.includes(platform);

export const getTrailerUrl = (
  videoRecording?: VideoRecording | UnauthorizedVideoRecording
) =>
  hasVideoRecording(videoRecording)
    ? `${Config.RECORDINGS_URL}/packaged/${videoRecording.sessionId}/${
        videoRecording.id
      }/trailer/stream_0/vod.mp4?recording_access_token=${encodeURIComponent(
        videoRecording.recordingAccessToken
      )}`
    : null;
